<template>
<div>
  <div class="columns">
    <div class="column">
      <h4 class="title is-4">{{ scraper.name }}</h4>
      <p>{{ scraper.description }}</p>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <div class="columns">
        <div class="column">
          <text-input
            required
            v-model="functions"
            description="Comma separated PHP function names, e.g. eval, assert, create_function. The SDK reports the file, line and whether an argument is dynamic for each call. No source code is uploaded.">
            Functions
          </text-input>
        </div>
      </div>
      <submit-button
        :working="saving"
        @submit="saveScraper"
        left-icon="save">
        Save
      </submit-button>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import Scraper from '@/store/models/Scraper'
import Example from './Example.vue'

export default {

  components: {
    Example
  },
  
  props: {
    scraper: {
      type: Object,
      default: () => (new Scraper())
    }
  },

  data: () => ({
    saving: false,
    functions: ''
  }),

  created() {
    const existing = (this.builder.scraper_payload && this.builder.scraper_payload.functions) || []
    this.functions = existing.join(', ')
  },

  methods: {
    updateScraperPayload() {
      this.$store.commit('scraperBuilder/updateScraperPayload', {
        functions: this.functions
          .split(',')
          .map(name => name.trim().toLowerCase())
          .filter(name => /^[a-z_][a-z0-9_]*$/.test(name))
      })
    },
    saveScraper() {
      this.saving = true
      this.$store.dispatch(`scraperBuilder/${this.action}`, this.scraper.id).then(() => {
        this.saving = false
        this.$toast.success('Scraper Saved')
        this.$router.push({
          name: 'scrapers'
        })
      }).catch(error => {
        this.saving = false
        this.$toast.error('Whoops, something went wrong')
      })
    }
  },

  computed: {
    ...mapGetters('scraperBuilder', [
      'builder'
    ]),
    action() {
      return this.builder.id ? 'updateScraper' : 'createScraper'
    }
  },

  watch: {
    functions: 'updateScraperPayload'
  }

}
</script>